import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import DataTable from "../../../../components/Common/DataTable/DataTable";
import { useFetchData } from "../../../../hooks/useFetchData";
import { getSubmissionsDataActionHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import { moderateContributions } from "../../../../utils/mainTabs/social/moderateContributions";
import { submisssions } from "../../../../utils/mainTabs/social/submissions";

const Submissions = () => {
  const pageSize = 8;
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tenantName } = useOutletContext();
  const [tableColumns, setTableColumns] = useState([]);
  const { searchPlaceHolder } = submisssions;
  const { submissionsColumns } = moderateContributions;
  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getSubmissionsDataActionHandler, pageSize);

  useEffect(() => {
    let newTableColumns = submissionsColumns(
      location,
      navigate,
      dispatch,
      handleSearchQuery,
      tenantName
    );
    setTableColumns(newTableColumns);
  }, [submissionsColumns, location, navigate, dispatch, tenantName]);

  return (
    <DataTable
      columns={tableColumns}
      defaultData={data}
      setDefaultData={setData}
      data={updatedData}
      setData={setUpdatedData}
      totalRows={totalRows}
      loading={loading}
      uniqueFieldName={"ID"}
      fetchMoreData={handleCurrentPage}
      searchable
      setSearchQuery={handleSearchQuery}
      placeholder={searchPlaceHolder}
    />
  );
};

export default Submissions;
